// extracted by mini-css-extract-plugin
module.exports =  {"content-footer":"HOn5e1f","contentFooter":"HOn5e1f"};